<template>
  <b-tooltip :target="target" triggers="hover" placement="bottomleft">
    <div v-for="(item, index) in objectArray" :key="index" class="text-left">
      <b v-if="item.value">{{item.text}} {{ item.value }}</b>
      <br v-if="item.space" />
    </div>
  </b-tooltip>
</template>
<script>
export default {
  props: ['target', 'objectArray']
}
</script>